import React from 'react'
import { motion } from 'framer-motion'
import Toast from './Toast'
import { useToast } from '../../hooks/useToast'

const ToastContainer = () => {
  const { toasts } = useToast()

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2">
      {toasts.map((toast) => (
        <Toast key={toast.id} {...toast} />
      ))}
    </div>
  )
}

export default ToastContainer